// PresentationCreator.js

import React, { useState } from 'react';
import { Container, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel, Button, Typography, Box } from '@mui/material';
import { getPresentation } from '../../Api/services/ppt';
import { toast } from 'react-toastify';
import {text} from "./constants.js"
import axios from 'axios';

export const Presentation = () => {
  const [formData, setFormData] = useState({
    numberOfSlides: '',
    userText: '',
    presentation_title: '',
    presenter_name: '',
    insert_image: false,
    template_choice: ''
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
        "numberOfSlides": 5,
        "userText": formData.userText,
        "presentation_title": formData.presentation_title,
        "presenter_name": formData.presenter_name,
        "insert_image": formData.insert_image,
        "template_choice": formData.template_choice
    }
    
    axios({
      url: 'https://lab.teamyab.com/api/ppt/ppt', // Replace with your endpoint URL
      method: 'POST',
      responseType: 'blob', // Important: ensures the response is a blob
      data: data
    })
    .then(res => {
      const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      const newUrl = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = newUrl;
      link.setAttribute('download', 'filename.pptx'); // Replace with the desired file name
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link); // Clean up and remove the link
      URL.revokeObjectURL(newUrl); // Release the object URL after download
    }).catch(err=>{
        toast(text.errorMsg, 'error')
    })
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Presentation Creator
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Number of Slides"
            name="numberOfSlides"
            value={formData.numberOfSlides}
            onChange={handleChange}
            margin="normal"
            type="number"
            required
          />
          <TextField
            fullWidth
            label="Description"
            name="userText"
            value={formData.userText}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={4}
            required
          />
          <TextField
            fullWidth
            label="Title"
            name="presentation_title"
            value={formData.presentation_title}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Presenter Name"
            name="presenter_name"
            value={formData.presenter_name}
            onChange={handleChange}
            margin="normal"
            required
          />
          <FormControlLabel
            control={
              <Checkbox
                name="insert_image"
                checked={formData.insert_image}
                onChange={handleChange}
              />
            }
            label="Insert Image"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="template-style-label">Template Style</InputLabel>
            <Select
              labelId="template-style-label"
              name="template_choice"
              value={formData.template_choice}
              onChange={handleChange}
              required
            >
              <MenuItem value="simple">Simple</MenuItem>
              <MenuItem value="dark_modern">Dark Modern</MenuItem>
              <MenuItem value="bright_modern">Bright Modern</MenuItem>
            </Select>
          </FormControl>
          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Button type="submit" variant="outlined" color="primary">
              Create Presentation
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

